import React, { useState } from "react";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import { useStyles } from "../../assets/jss/SearchResultGroupCard";
import clsx from "clsx";
import groupIcon from "../../assets/images/addGroup.svg";
import CustomLink from "../CustomComponents/CustomLink/CustomLink";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import { useTranslation } from "react-i18next";

export default function SearchResultGroupCard(props) {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const [cardData] = useState(props.groupData);
  return (
    <CustomPaper square elevation={0} className={clsx(classes.cardWrapper)}>
      {cardData ? (
        <>
          <CustomLink
            className={clsx(
              classes.cardLink
            )}
            href={`/admin/groups/view/${cardData.groupId}`}
          >
            <CustomCard
              elevation={0}
              className={clsx(classes.cardContentWrapper)}
            >
              <CustomCardContent className={classes.cardContent}>
                <CustomBox className={classes.iconWrapper}>
                  <img
                    width={70}
                    src={groupIcon}
                    alt="Icon"
                    className={classes.icon}
                  />
                </CustomBox>
                <CustomBox className={classes.cardName}>
                  {cardData.groupName}
                </CustomBox>
                <CustomBox className={classes.cardLabel}>{t("GROUP_ADMIN")}</CustomBox>
                {cardData.groupAdminList && cardData.groupAdminList.length ? (
                  <CustomBox className={classes.cardValue}>
                    {cardData.groupAdminList[0].name}{" "}
                    {cardData.groupAdminList.length > 1 ? (
                      <CustomBox component="span" className={classes.cardValueSmall}>
                        {i18n.t("AND_COUNT_OTHERS", { listCount: cardData.groupAdminList.length - 1 })}
                      </CustomBox>
                    ) : null}
                  </CustomBox>
                ) : 'N/A'}
                <CustomBox className={classes.cardLabel}>{t("TOTAL_USERS")}</CustomBox>
                <CustomBox className={classes.cardValue}>
                  {cardData.userCount ? cardData.userCount : 'N/A'}
                </CustomBox>
              </CustomCardContent>
            </CustomCard>
          </CustomLink>
        </>
      ) : null}
    </CustomPaper>

  );
}
